import React, { useState } from 'react';
import {AAC_REGISTER} from "src/constants/Steps";
import up_right_arrow from 'src/images/icon/up_right_arrow.png';
import doc_icon from 'src/images/icon/white_doc_icon.png';
import '../assets/registrationSection.scss';
import initialMetricsPublisher from '../metrics';
import {REGISTRATION_URL, NEW_TAB} from "src/constants/Links";
import AssignRegistrationModal from '../components/AssignRegistrationModal';
import customers from 'src/images/icon/customers.svg';

const RegistrationSection: React.FC = () => {
    const [hasInteracted, setHasInteracted] = useState(false);
    const [copied, setCopied] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleInteraction = () => {
        if (!hasInteracted) {
            const actionPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('RegistrationSectionInteraction');
            actionPublisher.publishCounterMonitor('InteractedWithRegistrationSectionCount', 1);
            setHasInteracted(true);
        }
    };

    const handleCopyRegistrationUrl = async () => {
        try {
            await navigator.clipboard.writeText(REGISTRATION_URL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset 'copied' state after 2 seconds
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <div className="section" id={AAC_REGISTER} onClick={handleInteraction}>
            <h1 className="page-heading">3. Register for Amazon Seller Central</h1>
            <p className="page-description"><strong>Before you begin:</strong></p>
            <p className="sub-heading">1. Assign a Primary Account Owner</p>
            <p className="page-description">The Primary Account Owner must complete the entire Seller Central registration process, whether it’s you or another employee. We use their personal information and IDs to verify your dealership, so only one person can enter information during registration.</p>

            <p className="sub-heading">2. Choose a shared email address to register</p>
            <p className="page-description">Your Seller Central login email can’t be changed, so choose an email that multiple people at your dealership have access to. This ensures that your dealership won’t lose access to that email if someone leaves or is unavailable. You can use the main generic email for your dealership, or create a new email just for your Seller Central account. </p>

            <p className="sub-heading">3. Have the following information handy</p>
            <ul>
                <li>General business info like business type, business address, etc.</li>
                <li>Driver’s license or passport for the Primary Account Owner</li>
                <li>Dealership’s bank account and routing numbers for direct deposit payouts</li>
                <li>Dealership’s credit card for the refundable $39.99 Seller Central fee. It will be refunded 4-6 weeks after registration complete.</li>
                <li>A device that can take video calls for your in-person identity verification</li>
            </ul>

            <p className="page-description registration-important"><strong>IMPORTANT:</strong> If you have an existing Seller Central account with Amazon you must register with a different email address and mobile number. </p>

            <div className="no-border-section">
                <div className="button-group">
                    <button
                        type="button"
                        className="assign-button"
                        onClick={() => {
                            handleInteraction();
                            const actionPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('SellerCentralRegistration');
                            actionPublisher.publishCounterMonitor('SellerCentralRegistrationLinkVisitsCount', 1);
                            setIsModalOpen(true);
                        }}
                    >
                        Assign to another employee
                        <img src={customers} alt="" />
                    </button>
                    <button
                        type="button"
                        className="submit-button"
                        onClick={() => {
                            handleInteraction();
                            const actionPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('SellerCentralRegistration');
                            actionPublisher.publishCounterMonitor('SellerCentralRegistrationLinkVisitsCount', 1);
                            window.open(REGISTRATION_URL, NEW_TAB)
                        }}
                    >
                        Begin registration
                        <img src={up_right_arrow} alt="" />
                    </button>
                </div>
                <button
                    type="button"
                    className="copy-text-button"
                    onClick={() => {
                        handleInteraction();
                        const actionPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('SellerCentralRegistration');
                        actionPublisher.publishCounterMonitor('SellerCentralRegistrationLinkVisitsCount', 1);
                        handleCopyRegistrationUrl();
                    }}
                >
                    {copied ? 'Link copied to clipboard!' : 'Copy registration link'}
                    {copied ? '' : <img src={doc_icon} alt="" />}
                </button>
            </div>

            <AssignRegistrationModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
            />
        </div>
    );
};

export default RegistrationSection;
